import React from 'react';
import { Button as UiButton, ButtonProps } from '@make-software/cspr-ui';

type UIButtonProps = ButtonProps &
  React.ButtonHTMLAttributes<HTMLButtonElement>;

export const Button = (props: UIButtonProps) => (
  <UiButton lineHeight={'xs'} {...props} hasOutline />
);
